import { fieldTypes } from "../constants";
import { FIELD_TYPES_BY_SPECIALTY } from "app/provider-panel/constants/fields";
import { map, filter } from "lodash";

export const initialValuesFactory = ({ provider, practiceTeamParticipant, isPrincipal, ...context }) => {
  const { availableParticipantStates, licenses, providerExtension } = provider;
  const { practiceTeam, providerPanelExtension, states = [] } = practiceTeamParticipant || {};
  const initialValues = { [fieldTypes.IS_PRINCIPAL]: isPrincipal };

  FIELD_TYPES_BY_SPECIALTY[context.specialtyCode].forEach((fieldType) => {
    switch (fieldType) {
      case fieldTypes.PRACTICE_TEAM:
        initialValues[fieldType] = practiceTeam ? { value: practiceTeam.id, label: practiceTeam.name } : null;
        break;
      case fieldTypes.STATES:
        initialValues[fieldType] = (isPrincipal ? availableParticipantStates : states).map((state) => ({
          value: state,
        }));
        break;
      case fieldTypes.MAX_PANEL:
        initialValues[fieldType] = providerPanelExtension ? providerPanelExtension.maxSize : '';
        break;
      case fieldTypes.SHARE_PANEL:
        const shares = providerPanelExtension ? providerPanelExtension.shares : [];
        initialValues[fieldType] = shares.map(({ shareToPerson: { id, nameWithCredentials } }) => ({
          value: id,
          label: nameWithCredentials,
        }));
        break;
      case fieldTypes.NEW_PATIENTS_DAILY_LIMIT:
        initialValues[fieldType] = providerPanelExtension ? providerPanelExtension.dailyNewPatientLimit : '';
        break;
      case fieldTypes.NEW_PATIENT_STATES:
        initialValues[fieldType] = licenses.length ? map(filter(licenses, 'acceptingNewPatients'), 'stateCd') : null;
        break;
      case fieldTypes.ACCEPT_NEW_PATIENTS:
        initialValues[fieldType] =  !providerExtension || providerExtension.acceptingNewPatients === true;
        break;
      default:
        throw new Error(`Unknown field type: ${fieldType}`);
    }
  });

  return initialValues;
};
